/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { PassThroughBody, PassThroughBodyFromJSON, PassThroughBodyToJSON } from './PassThroughBody'

/**
 *
 * @export
 * @interface CreateFolderRequest
 */
export interface CreateFolderRequest {
  /**
   * The name of the folder.
   * @type {string}
   * @memberof CreateFolderRequest
   */
  name: string
  /**
   * The parent folder to create the new file within. This can be an ID or a path depending on the downstream folder. Please see the connector section below to see downstream specific gotchas.
   * @type {string}
   * @memberof CreateFolderRequest
   */
  parent_folder_id: string
  /**
   * A unique identifier for an object.
   * @type {string}
   * @memberof CreateFolderRequest
   */
  readonly id?: string
  /**
   * Optional description of the folder.
   * @type {string}
   * @memberof CreateFolderRequest
   */
  description?: string
  /**
   * ID of the drive to create the folder in.
   * @type {string}
   * @memberof CreateFolderRequest
   */
  drive_id?: string
  /**
   *
   * @type {PassThroughBody}
   * @memberof CreateFolderRequest
   */
  pass_through?: PassThroughBody
}

export function CreateFolderRequestFromJSON(json: any): CreateFolderRequest {
  return CreateFolderRequestFromJSONTyped(json, false)
}

export function CreateFolderRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateFolderRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    parent_folder_id: json['parent_folder_id'],
    id: !exists(json, 'id') ? undefined : json['id'],
    description: !exists(json, 'description') ? undefined : json['description'],
    drive_id: !exists(json, 'drive_id') ? undefined : json['drive_id'],
    pass_through: !exists(json, 'pass_through')
      ? undefined
      : PassThroughBodyFromJSON(json['pass_through'])
  }
}

export function CreateFolderRequestToJSON(value?: CreateFolderRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    parent_folder_id: value.parent_folder_id,
    description: value.description,
    drive_id: value.drive_id,
    pass_through: PassThroughBodyToJSON(value.pass_through)
  }
}
